import ProductDescription from './ProductDescription'

const CannedVegsFruitsProduct = {
  ...ProductDescription,
  category: '19',
  subCategory: '001CF',
  IsBroadband: true,
  ItemType: '',
  Size: '',
  ContainerType: '',
  packageType: '',
  Packaged: '',
  noAddtlIngredients: false,
  OrganicVerification: false,
  CannedProductType: 'Fruit',
  otherType: '',
  otherContainerType: '',
}

export default CannedVegsFruitsProduct
